export function parseDate(date: string) {
  const d = new Date(date)
  const day = parseInt(
    d.toLocaleDateString('us', {
      day: 'numeric',
    }),
    10
  )
  const month = d.toLocaleDateString('us', {
    month: 'long',
  })

  return `${getNumberWithOrdinal(day)} of ${month}`
}

function getNumberWithOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}
